import React, { useState } from 'react';
import { Modal, Button } from '../ui-kit';
import { IconEdit } from '../ui-kit/icons';
import SkillEditTableStandalone from './SkillEditTableStandalone';

const SkillEditPopover = ({ membershipIds, groupId, groupName, userId }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const handleReload = () => globalThis.location.reload();

  return (
    <>
      <Button variant="warning" size="sm" onClick={handleShow} title={I18n.t('skills.manage')}>
        <IconEdit />
      </Button>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{`${I18n.t('skills.manage')} (${groupName})`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SkillEditTableStandalone membershipIds={membershipIds} groupId={groupId} userId={userId} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleReload}>
            {I18n.t('refresh')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SkillEditPopover;
